import React, { FC, useEffect } from "react";

interface LabelIconI {
  color?: HexColor;
}

type HexColor = `#${string}`;

const isHexColor = (value: string): value is HexColor => {
  const hexColorRegex = /^#([0-9a-fA-F]{3}){1,2}$/;
  return hexColorRegex.test(value);
};

const LabelIcon: FC<LabelIconI> = (props) => {
  const { color = "#000" } = props;

  useEffect(() => {
    try {
      if (!isHexColor(color)) {
        throw new Error("Invalid hex color format");
      }
    } catch (error) {
      console.error(error);
    }
  }, [color]);

  return (
    <div className="label-icon">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.5293 13.6786L15.9902 17.3493C15.5878 17.7667 15.0448 17.999 14.4764 17.9988L6.14475 18C4.96111 18 4 17.0031 4 15.7754L4 9.22455C4 7.99687 4.96111 7 6.14475 7L14.4764 7.00123C15.0447 7.00106 15.5878 7.23326 15.9903 7.65067L19.5293 11.3214C20.1569 11.9723 20.1569 13.0277 19.5293 13.6786ZM14.6054 11.7143C14.1864 12.1489 14.1864 12.8511 14.6054 13.2857C15.0244 13.7203 15.7014 13.7203 16.1205 13.2857C16.5387 12.8519 16.5395 12.1489 16.1205 11.7143C15.7014 11.2797 15.0237 11.2804 14.6054 11.7143Z"
          fill={isHexColor(color) ? color : "#000"}
        />
      </svg>
    </div>
  );
};

export default LabelIcon;
